import React from 'react';
import PageTitle from '../../FormElements/PageTitle';
import PrimaryButton from '../../Buttons/PrimaryButton';

export default class CartSuccess extends React.Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth'
		});
	}

	render() {
		// console.log("CartSuccess", this.props)
		return (
			<div className="CartSuccessPartial pb-4">
				<div className="pt-4 flex justify-start">
					<PageTitle title="Success!" />
				</div>
				<div>
					<p className="mb-4 mt-2 lg:mt-0 font-light">
						Next, we need to gather a few more pieces of information regarding
						your property in order to apply for your business licenses and start
						filing your lodging taxes.
					</p>
					<div className="grid">
						<div className="lg:justify-self-end">
							<PrimaryButton label="Go to dashboard" url="/dashboard" />
						</div>
					</div>
				</div>
			</div>
		);
	}
}
